import { gql } from 'graphql-request';

export const COUNTRY_FRAGMENT = gql`
    fragment CountryFields on Country {
        id
        name
        abbreviation
        continent
        timezone
        phoneInternationalPrefix
    }    
`